import AsyncStorage from "@react-native-async-storage/async-storage";
import { postData } from "../networking/api";

export const fetchProjectBasedOn = async () => {
  try {
    const projValue = await AsyncStorage.getItem("projectCode");

    if (!projValue) {
      return 1;
    }

    const ProfileData = JSON.stringify({
      module: "project",
      condition: {
        project_code: JSON.parse(projValue),
      },
    });

    const response = await postData(
      ProfileData,
      "/masters/getMasterList"
    );

    if (
      response?.status === 200 &&
      response?.data?.length > 0
    ) {
      return response.data[0].based_on;
    }

    return 1;
  } catch (error) {
    console.error("Error fetching project data:", error);
    return 1;
  }
};